import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon, ClockIcon, RepeatIcon } from 'lucide-react';
import { useStore } from '../contexts/StoreContext';
import type { Treatment } from '../data/treatments';
export function TreatmentList({
  items
}: {
  items: Treatment[];
}) {
  const {
    openBooking
  } = useStore();
  const [openSlug, setOpenSlug] = useState<string | null>(items[0]?.slug ?? null);
  return <ul className="border-t border-line" data-id="element-228" data-mp="305j7wxgihhh3">
      {items.map(t => {
      const isOpen = openSlug === t.slug;
      return <li key={t.slug} className="border-b border-line" data-id="element-229" data-mp="2q5sbgq8e4sed">
            <h3 data-id="element-230" data-mp="2q6aeq6th06vs">
              <button type="button" aria-expanded={isOpen} onClick={() => setOpenSlug(isOpen ? null : t.slug)} className="group flex w-full items-baseline gap-4 py-6 text-left sm:gap-8" data-id="element-231" data-mp="2q7vau0vfnxvr">
                <span className="flex-1" data-id="element-232" data-mp="jg3y9uvs0i27">
                  <span className="block font-display text-2xl font-light leading-tight text-ink transition-colors duration-150 ease-soft group-hover:text-clay sm:text-[1.85rem]" data-id="element-233" data-mp="3kmofuvo0afut">
                    {t.name}
                  </span>
                  <span className="mt-1.5 block text-[13px] text-muted" data-id="element-234" data-mp="3apk1hi0ejook">{t.tagline}</span>
                </span>
                <span className="hidden whitespace-nowrap text-[13px] text-muted sm:block" data-id="element-235" data-mp="3fod3oea8nt9f">
                  {t.duration}
                </span>
                <span className="whitespace-nowrap font-display text-lg text-ink" data-id="element-236" data-mp="c6v9h9ne2krh">{t.price}</span>
                <span className="text-muted transition-colors duration-150 ease-soft group-hover:text-ink" data-id="element-237" data-mp="c8pn02wbzalj">
                  {isOpen ? <MinusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-238" data-mp="2g09l2h7zmnk" /> : <PlusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-239" data-mp="q6e20u3pvnio" />}
                </span>
              </button>
            </h3>

            <AnimatePresence initial={false} data-id="element-240" data-mp="uzfk1az8036h">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.24,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-241" data-mp="14stbx9gu5vjw">
                  <div className="grid gap-6 pb-8 lg:grid-cols-12 lg:gap-10" data-id="element-242" data-mp="qvwozj3u8y8a">
                    <p className="text-[15px] leading-relaxed text-muted lg:col-span-7" data-id="element-243" data-mp="lvs7bpr71xgh">
                      {t.description}
                    </p>
                    <div className="lg:col-span-5" data-id="element-244" data-mp="c3w5c3lzln6z">
                      <ul className="flex flex-wrap gap-2" data-id="element-245" data-mp="c2l2q74a2lhg">
                        {t.focus.map(f => <li key={f} className="rounded-full border border-line px-3 py-1 text-[12px] text-muted" data-id="element-246" data-mp="8199lrm73i4i">
                            {f}
                          </li>)}
                        {t.bindweefsel && <li className="rounded-full bg-blush px-3 py-1 text-[12px] text-ink" data-id="element-247" data-mp="2eqjmgbh9nkwk">
                            Incl. bindweefselmassage
                          </li>}
                      </ul>

                      <dl className="mt-5 space-y-2 text-[13px]" data-id="element-248" data-mp="2nrhgq21wke1y">
                        <div className="flex items-center gap-2 text-muted" data-id="element-249" data-mp="1r2jkefei882o">
                          <ClockIcon className="h-3.5 w-3.5 text-clay" strokeWidth={1.5} data-id="element-250" data-mp="1w0lfjyp7fxui" />
                          <dt className="sr-only" data-id="element-251" data-mp="202geiwjnxz54">Duur</dt>
                          <dd data-id="element-252" data-mp="200vl5a934m8u">
                            {t.duration} · {t.price}
                          </dd>
                        </div>
                        {t.kuur && <div className="flex items-center gap-2 text-muted" data-id="element-253" data-mp="18a7n472pjwze">
                            <RepeatIcon className="h-3.5 w-3.5 text-clay" strokeWidth={1.5} data-id="element-254" data-mp="1ccc9ckqttrc0" />
                            <dt className="sr-only" data-id="element-255" data-mp="t7pn0pg2gaij">Kuur</dt>
                            <dd data-id="element-256" data-mp="t64uf5dbb1nb">{t.kuur}</dd>
                          </div>}
                      </dl>

                      <button type="button" onClick={() => openBooking(t.name)} className="mt-6 rounded-full bg-ink px-6 py-3 text-[13px] text-shell transition-colors duration-150 ease-soft hover:bg-clay" data-id="element-257" data-mp="12xsf8nfd5kft">
                        Boek {t.name}
                      </button>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}